import { z } from 'zod';

const nullableOptionalString = z.string().nullable().optional();

// Schéma de validation runtime des utilisateurs renvoyés par l'API OAuthClient.
export const oauthClientUserSchema = z.object({
  InstanceId: z.string().min(1),
  LastName: nullableOptionalString,
  FirstName: nullableOptionalString,
  Email: nullableOptionalString,
  Actif: z.boolean(),
  Profile: nullableOptionalString,
  ProfileId: nullableOptionalString,
});

export const oauthClientUserListSchema = z.array(oauthClientUserSchema);

export type OAuthClientUser = z.infer<typeof oauthClientUserSchema>;
